export const armarDia = (dia)=>{
    //cerrado todo el dia
    if(dia.MatDesde == dia.VesHasta){
        return `${dia.Dia}: Cerrado`
    }

    // cerrado en la mañana
    if(dia.MatDesde == dia.MatHasta){
        return `${dia.Dia}: Cerrado, ${dia.VesDesde} - ${dia.VesHasta}`
    }

    //cerrado en la tarde
    if(dia.VesDesde == dia.VesHasta){
        return `${dia.Dia}: ${dia.MatDesde} - ${dia.MatHasta}, Cerrado` 
    }

    return `${dia.Dia}: ${dia.MatDesde} - ${dia.MatHasta}, ${dia.VesDesde} - ${dia.VesHasta}`
}

export const ordenarDias = (horarios) => horarios.sort((a, b)=> a.Indice - b.Indice)